
document.addEventListener("DOMContentLoaded", function() {
  var target = document.querySelector(".PageContent");

  function deliveryDateLayout() {
    var insertParent = document.querySelector(".Cart__Recap");
    var insertPosition = document.querySelector(".Cart__Checkout");
    var deliveryDateWrapper = document.querySelector("#deliveryDate__wrapper");

    if (!insertParent || !insertPosition || !deliveryDateWrapper) {
      return false;
    }

    if (insertPosition.parentNode !== insertParent) {
      return false;
    }

    if (deliveryDateWrapper.parentNode === insertParent &&
        deliveryDateWrapper.nextElementSibling === insertPosition) {
      return true;
    }

    insertParent.insertBefore(deliveryDateWrapper, insertPosition);
    return true;
  }

  if (deliveryDateLayout()) {
    return;
  }

  if (!target) {
    return;
  }

  var observer = new MutationObserver(function(records) {
    var cartAdded = records.some(function(record) {
      if (record.type !== "childList") {
        return false;
      }

      return Array.from(record.addedNodes).some(function(node) {
        return node.nodeType === Node.ELEMENT_NODE &&
          (
            node.classList.contains("Cart") ||
            (node.querySelector && node.querySelector(".Cart"))
          );
      });
    });

    if (cartAdded && deliveryDateLayout()) {
      observer.disconnect();
    }
  });

  var config = {
    childList: true,
    characterData: true,
    subtree: true
  };

  observer.observe(target, config);
});
